// Backend order numbers look like "SO-2026-07-06-0001". Customers only need the
// trailing sequence ("0001") — it's far easier to read out and remember. Staff
// still see the full number elsewhere.
export const shortOrderNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  const parts = String(value).split("-");
  return parts[parts.length - 1] || String(value);
};
